<template>
  <div>
    <v-container fluid class="content-container content-top-container">
      <v-layout column>
        <img src="/images/library.png" class="library-img" />
        <browsing-tags :onChangeTags="changeTags"></browsing-tags> 
      </v-layout>
      <v-layout column>
        <language-tags :onChangeLanguageTags="changeLanguageTags"></language-tags> 
      </v-layout>
    </v-container>
    <v-container fluid class="content-container content-main-container">
      <v-layout row wrap>
        <v-flex md9 xs12 sm12>
          <!-- <div class="heading then-cardlist heading-top">Browse Books</div> -->

          <!-- <div class="library-mark">
            <div class="library-box">Pubby Library</div>
            <div class="library-subhead">
              Our book selection changes throughout the day.
              <br />Check back often for more books!
            </div>
            <div class="library-decoration">
              <div class="library-decoration-circle"></div>
              <div class="library-decoration-line"></div>
              <div class="library-decoration-circle"></div>
            </div>
          </div> -->
          <template v-if="isIneligible">
            <div class="limit-title">Friend Accounts Disabled</div>
            <div class="limit-limit-instructions">
              To ensure that all authors can find a book to review, we have disabled
              Friend Accounts.
              <br />If you are an author and want to continue using Pubby to get
              reviews for your own work, please create a full account.
            </div>
          </template>
          <template v-else-if="!canPick">
            <div class="limit-title">Reading Limit Reached</div>
            <div class="limit-limit-instructions">
              To ensure that all readers can find a book to review, we allow
              each user to review up to {{ readingLimitToText }} book{{ pluralizeBooks }} at a time.
              <br />Please complete or cancel {{ limitCancelInstructions }}
              before choosing a new book to review.
            </div>
          </template>
          <template v-else-if="isWeeklyLimitReached">
            <div class="limit-title">Weekly Reading Limit Reached</div>
            <div class="limit-limit-instructions">
              <!-- <div v-if="isUserConsideredNew()">
                Members new to Pubby are allowed to review up to 7 books each
                week. After two weeks, you're allowed to review up to 10 books
                each week. This helps us ensure everyone has a chance to read
                books from our library while still abiding by Amazon's
                guidelines.
                <br />
                <br />You will be able to pick your next book at:
                {{ getWeeklyLimitEndTime() }}
              </div> -->
              <div>
                In order to allow everyone a chance to read books from our
                library while still abiding by Amazon's guidelines, we
                currently allow members to review up to {{ weeklyReadingLimit }} books every seven
                days.
                <br />
                <br />You will be able to pick your next book at:
                {{ getWeeklyLimitEndTime() }}
              </div>
            </div>
          </template>
          <template v-else-if="isUnapprovedLimitedReached">
            <div class="limit-title">You have 4 reviews awaiting approval</div>
            <div class="limit-limit-instructions limit-limit-instructions-left">
              We're in the process of verifying 4 reviews that you turned in
              recently. Please allow us to approve at least one of these reviews
              before you sign up to read more books.
              <br />
              <br />It typically takes 1 to 2 days to verify each review. If you
              recently wrote your first review on Amazon, it typically takes
              2 to 3 days for Amazon to approve it.
              <br />
              <br />If you have any questions, you can chat with us by clicking
              the yellow button in the bottom-right corner of the screen. Thank
              you for your patience!
            </div>
          </template>
          <template v-else-if="isNoBooks">
            <div class="limit-title">Add Your Book to Pubby</div>
            <div class="limit-limit-instructions">
              Please add at least one of your books to Pubby before using our
              library.
              <br />
              <br />
              <div class="action" @click="$router.push('/books/add')">
                Add Book
              </div>
            </div>
          </template>
          <template v-else-if="suspendedPendingActionCount">
            <div v-if="suspendedPendingActionCount === 1" class="limit-title">You have a pending action</div>
            <div v-else class="limit-title">You have pending actions</div>
            <div class="limit-limit-instructions" v-html="actionRequestedMessage">
            </div>
          </template>
          <template v-else-if="isLibrarySuspended">
            <div class="limit-title">Library Suspended</div>
            <div class="limit-limit-instructions" v-html="user.suspend_library">
            </div>
          </template>
          <template v-else>
            <v-container class="library-books-container">
              <v-layout v-if="isReadingWarningReached && false">
                <div class="policy-warning-container"></div>
                <div class="policy-warning">
                  <div class="policy-warning-image">
                    <img
                      src="/images/policy-warning.jpg"
                      class="policy-warning-image-img"
                    />
                  </div>
                  <div class="policy-warning-text">
                    <p>
                      <b>Note:</b> You've picked {{ booksReadThisWeek }} books
                      to read during the last 7 days. While writing many reviews
                      in one week does not violate Amazon's terms of service, it
                      can often cause Amazon's automated system to flag your
                      activity as suspicious and potentially block your ability
                      to leave reviews in the future.
                    </p>
                    <p>
                      In order to maintain in good standing on Amazon, we
                      recommend waiting until this time to leave your next
                      review:<br /><b>{{ getWeeklyLimitEndTime() }}</b>
                    </p>
                  </div>
                </div>
              </v-layout>
              <v-layout
                row
                wrap
                class="books-container"
                :class="{ 'books-refreshing': !isBooksLoaded }"
                v-for="(assignments, list) in recommendations"
                :key="list"
              >
                <div class="books-list-heading">
                  <div class="books-list-label">{{ list }}</div>
                  <div
                    class="books-list-selection"
                    v-if="list === 'Your Picks' || list === 'Choose Genre'"
                  >
                    <v-select
                      v-model="preferredGenre"
                      :items="genres"
                      v-on:input="refresh"
                      :auto="true"
                      dense
                    >
                      <template slot="selection" slot-scope="data">{{
                        data.item.label
                      }}</template>
                      <template slot="item" slot-scope="data">{{
                        data.item.label
                      }}</template>
                    </v-select>
                  </div>
                  <div class="clearfix"></div>
                </div>

                <v-flex
                  sm12
                  md6
                  v-for="assignment in assignments"
                  :key="assignment.id"
                  @click="selectAssignment(assignment)"
                >
                  <card
                    :assignment="assignment"
                    :selected="selectedAssignmentId === assignment.id"
                    :find="true"
                  ></card>
                </v-flex>
              </v-layout>

              <div class="library-loading" v-if="!isBooksLoaded">
                <img class="library-loading-gif" src="/images/loading.gif" />
                <div class="library-loading-label">
                  One sec, we're finding you book recommendations!
                </div>
              </div>

              <div
                class="earncall grow"
                v-if="showBookHelp"
                @click="bookHelpClicked"
              >
                <div class="earncall-card">
                  <div class="earncall-icon">
                    <img class="earncall-icon-img" src="/images/earncall.png" />
                  </div>
                  <div class="earncall-heading">Can't find a book?</div>
                  <div class="earncall-description">
                    Check back soon, because new books are added each day!<br />In
                    the meantime, click here to see other ways to earn snaps.
                  </div>
                </div>
              </div>

              <!-- <div class="earncall" v-if="showThankYouHelp">
                <div class="earncall-card">
                  <div class="earncall-icon">
                    <img
                      class="earncall-icon-img"
                      src="/images/readers-thank-you.png"
                    />
                  </div>
                  <div class="earncall-heading">Thank you for reading!</div>
                  <div class="earncall-description">
                    Independent authors are incredibly grateful to you for
                    considering their books today. If you can't find a book
                    you're interested in right now, our selection changes each
                    day!
                  </div>
                </div>
              </div> -->

              <!-- <v-layout row wrap class="books-container">
                <v-flex
                  sm12
                  md6
                  v-for="assignment in recommendations"
                  :key="assignment.id"
                  @click="selectAssignment(assignment)"
                >
                  <card
                    :assignment="assignment"
                    :selected="selectedAssignmentId === assignment.id"
                    :find="true"
                  ></card>
                </v-flex>
              </v-layout>-->
            </v-container>
          </template>

          <div
            class="modal-container"
            :class="{
              'modal-tall':
                selectedAssignment.is_verified && user.is_choose_your_reward,
            }"
            v-if="selectedAssignmentId"
          >
            <div class="actions">
              <div class="action-selection">
                <div class="close-container">
                  <div
                    class="close-button"
                    @click="selectAssignment(selectedAssignment)"
                  >
                    <i class="material-icons close-button-icon">close</i>
                  </div>
                </div>

                <choose-your-bonus
                  :assignment="selectedAssignment"
                  :selected="selectedBonus"
                  :onSelect="selectBonus"
                  v-if="
                    selectedAssignment.is_verified && user.is_choose_your_reward
                  "
                ></choose-your-bonus>

                <template
                  v-if="
                    !selectedAssignment.is_verified ||
                    selectedBonus ||
                    !user.is_choose_your_reward
                  "
                >
                  <div
                    class="action action-blue"
                    :class="{ 'action-disabled': !selectedAssignmentId }"
                    @click="acceptAssignment()"
                  >
                    {{ actionLabel }}
                  </div>
                  <div class="confirm-text confirm-read-text">
                    <template v-if="selectedAssignmentId">
                      <!-- <template v-if="user.is_athlete">
                        Great pick! You'll have until the end of
                        <span class="date">{{
                          (selectedAssignment.due_at ||
                            selectedAssignment.proposed_due_at) | shortDate
                        }}</span>
                        to read and review this book.
                      </template> -->
                      <template
                        v-if="
                          selectedAssignment.is_verified &&
                          !user.is_choose_your_reward
                        "
                      >
                        You'll earn
                        <span class="points-text"
                          >{{
                            selectedAssignment.reward_points | bigNumber
                          }}
                          snaps</span
                        >
                        for reading
                        <span class="book-title">{{
                          selectedAssignment.book.title
                        }}</span>
                        <span>.</span>
                        <br />This includes a
                        <span class="snaps-bonus-text"
                          >{{
                            (selectedAssignment.listing_price * 300) | bigNumber
                          }}
                          snaps bonus</span
                        >
                        for purchasing the book on Amazon.
                        <span class="snaps-bonus-more" style="padding-left: 0em"
                          >(300 snaps per $1 spent)</span
                        >
                      </template>
                      <template v-else>
                        You'll earn
                        <span class="points-text"
                          >{{
                            selectedAssignment.reward_points | bigNumber
                          }}
                          snaps</span
                        >

                        <span
                          v-if="
                            selectedAssignment.is_verified &&
                            selectedBonus === 'credit'
                          "
                        >
                          and a
                          <span class="credit-bonus-text"
                            >${{
                              (selectedAssignment.listing_price * 1.5)
                                | shortDollars
                            }}
                            off your membership</span
                          >
                          this month
                        </span>
                        <span
                          v-if="
                            selectedAssignment.is_verified &&
                            selectedBonus === 'snaps'
                          "
                        >
                          and a
                          <span class="snaps-bonus-text"
                            >{{
                              (selectedAssignment.listing_price * 300)
                                | bigNumber
                            }}
                            snaps bonus</span
                          >
                        </span>
                        for reading
                        <span class="book-title">{{
                          selectedAssignment.book.title
                        }}</span
                        >.
                      </template>
                    </template>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </v-flex>
        <v-flex md3 xs12 sm12>
          <div class="genrelist-container">
            <genre-list
              :selectedGenreId="selectedGenreId"
              :selectedSubgenreIds="selectedSubgenreIds"
              :onClickItem="clickGenreItem"
              :onClickSubItem="clickSubgenreItem"
            ></genre-list>
          </div>
          <!-- <div
            class="reading-discount-container"
            v-if="user && user.is_choose_your_reward"
          >
            <div class="reading-discount-box">
              <reading-discount :user="user"></reading-discount>
            </div>
          </div> -->
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Back from "../modules/Back";
import Bus from "../modules/Bus";
import Card from "../components/Assignment/Card";
import ReadingDiscount from "../components/Library/ReadingDiscount";
import ChooseYourBonus from "../components/Library/ChooseYourBonus";
import { mapState } from "vuex";
import BrowsingTags from "../components/Library/BrowsingTags.vue";
import LanguageTags from "../components/Library/LanguageTags.vue";
import GenreList from "../components/Library/GenreList.vue";

export default {
  name: "FindBook",
  components: {
    Card,
    ReadingDiscount,
    ChooseYourBonus,
    BrowsingTags,
    LanguageTags,
    GenreList,
  },
  data: function () {
    return {
      dialog: false,
      recommendations: [],
      genres: null,
      languages: null,
      selectedAssignmentId: null,
      selectedAssignment: null,
      selectedBonus: null,
      isRefreshed: false,
      isStandard: false,
      isSpeedy: false,
      isNoBooks: false,
      isRequiresPurchase: false,
      preferredGenre: null,
      selectedTags: [],
      selectedLanguages: [],
      selectedGenreId: null,
      selectedSubgenreIds: [],
      editRequestedAssignments: [],
      deleteRequestedAssignments: [],
      page: 1,
      isBooksLoaded: false,
      actionRequested: false,
    };
  },
  computed: {
    ...mapState({
      user: "user",
      assignments: "assignments",
      readingLimit: "readingLimit",
      weeklyReadingLimit: "weeklyReadingLimit",
    }),
    actionLabel() {
      return this.selectedAssignmentId ? "Pick Book" : "Select Option";
    },
    showBookHelp() {
      return this.isBooksLoaded && this.user; // && !this.user.is_athlete;
    },
    // showThankYouHelp() {
    //   return this.isBooksLoaded && this.user && this.user.is_athlete;
    // },
    isIneligible() {
      if (this.user) {
        return this.user.is_friend
      }
      return false
    },
    readingLimitToText() {
      switch(this.readingLimit) {
        case 1:
          return "one";
        case 2:
          return "two";
        case 3:
          return "three";
        case 4:
          return "four";
        case 5:
          return "five";
        default:
          return this.readingLimit
      }
    },
    pluralizeBooks() {
      if (this.readingLimit > 1) { 
        return "s"
      } else return ""
    },
    limitCancelInstructions() {
      switch(this.readingLimit) {
        case 1:
          return "your active assignment"
        default:
          return "one of your " + this.readingLimitToText + " active assignments"
      }
    },
    canPick() {
      if (this.user) {
        // if (
        //   !this.hasOneBook(this.user) &&
        //   this.user.memberType !== 'friend' &&
        //   this.user.memberType !== 'free'
        // ) {
        //   this.isNoBooks = true;
        //   return true;
        // }

        if (this.user.memberType === "press") {
          return true;
        }
        if (
          this.user.id === 39 ||
          this.user.id === 245 ||
          this.user.id === 21
        ) {
          return true;
        }
      }

      let activeCount = 0;
      for (const assignment of this.assignments) {
        if (
          assignment.status === "Assigned" ||
          assignment.status === "Archived" ||
          assignment.status === "Waiting" ||
          assignment.status === "Rejected"
        ) {
          activeCount++;
        }
      }

      return activeCount < this.readingLimit;
    },
    isUnapprovedLimitedReached() {
      var firstAssignmentTime = null;
      var lastApprovedTime = null;
      var unapprovedCount = 0;
      var approvedCount = 0;

      for (const assignment of this.assignments) {
        if (assignment.status === "Approved") {
          approvedCount++;
        }

        if (
          assignment.status === "PendingApproval" ||
          assignment.status === "Rejected"
        ) {
          unapprovedCount++;
        }
      }

      if (approvedCount > 1) {
        return false;
      }

      if (unapprovedCount < 4) {
        // console.log("unapprovedCount", unapprovedCount);
        return false;
      }

      return true;

      const now = new Date();
      const nowTime = new Date().getTime();
      const startTime = lastApprovedTime
        ? lastApprovedTime
        : firstAssignmentTime;

      if (!startTime) {
        return false;
      }

      const diff = nowTime - (startTime - now.getTimezoneOffset() * 60 * 1000);

      if (diff > 86400 * 4 * 1000) {
        return true;
      }
    },
    isLibrarySuspended() {
      if (!this.user) {
        return false
      }
      return this.user.suspend_library
    },
    suspendedPendingActionCount() {
      var actionRequestedCount = 0
      for (const assignment of this.assignments) {
        if (assignment.status === "ActionRequested" && assignment.review_issue) {
          if (assignment.review_issue.request_edit) {
            this.editRequestedAssignments.push(assignment)
          }
          if (assignment.review_issue.request_delete) {
            this.deleteRequestedAssignments.push(assignment)
          }
          actionRequestedCount ++;
        }
      }

      return actionRequestedCount
    },
    actionRequestedMessage() {
    const editRequests = this.editRequestedAssignments.length
    const deleteRequests = this.deleteRequestedAssignments.length

    if (editRequests + deleteRequests === 0) {
      return null;
    }

    let message = `You will need to `
          if (editRequests) {
            message += `<u>edit</u> your review${editRequests>1 ? 's' : ''} of ${getBookTitlesFromAssignments(this.editRequestedAssignments)}`
          }
          if (deleteRequests) {
            if (editRequests) {
              message += ` and `
            }
            message += `<u>delete</u> your review${deleteRequests>1 ? 's' : ''} of ${getBookTitlesFromAssignments(this.deleteRequestedAssignments)}`
          }

      message += ` before being able to access the library again.`
      message += `<p>Note: Clicking ${(editRequests+deleteRequests>1 ? 'each' : 'the')} book title will take you to your assignment for further details.</p>`
  
      return message
    },
    booksReadThisWeek() {
      let activeCount = 0;
      const now = new Date();
      const nowTime = new Date().getTime();

      for (const assignment of this.assignments) {
        if (!assignment.started_at) {
          continue;
        }

        const assignmentDate = new Date(
          assignment.started_at.replace(/-/g, "/")
        );
        const assignmentTime = assignmentDate.getTime();

        const diff =
          nowTime - (assignmentTime - now.getTimezoneOffset() * 60 * 1000);

        if (diff < 604800 * 1000) {
          activeCount++;
        } else {
        }
      }


      return activeCount;
    },
    isReadingWarningReached() {
      let activeCount = 0;
      const now = new Date();
      const nowTime = new Date().getTime();

      for (const assignment of this.assignments) {
        if (!assignment.started_at) {
          continue;
        }

        const assignmentDate = new Date(
          assignment.started_at.replace(/-/g, "/")
        );
        const assignmentTime = assignmentDate.getTime();

        const diff =
          nowTime - (assignmentTime - now.getTimezoneOffset() * 60 * 1000);

        if (diff < 604800 * 1000) {
          activeCount++;
        } else {
        }
      }

      var weeklyLimit = 7;

      var createdAtDate = new Date(
        this.user.readerStats.created_at.replace(/-/g, "/")
      );
      var createdAtTime = createdAtDate.getTime();
      const createdAtDiff =
        nowTime - (createdAtTime - now.getTimezoneOffset() * 60 * 1000);
      if (createdAtDiff < 604800 * 2 * 1000) {
        weeklyLimit = 7;
      }

      return activeCount >= weeklyLimit;
    },
    isWeeklyLimitReached() {
      if (this.user) {
        if (this.user.memberType === "press") {
          return false;
        }
        if (
          this.user.id === 39 ||
          this.user.id === 245 ||
          this.user.id === 21
        ) {
          return false;
        }
      }

      let activeCount = 0;
      const now = new Date();
      const nowTime = new Date().getTime();

      for (const assignment of this.assignments) {
        if (!assignment.started_at) {
          continue;
        }

        const assignmentDate = new Date(
          assignment.started_at.replace(/-/g, "/")
        );
        const assignmentTime = assignmentDate.getTime();

        const diff =
          nowTime - (assignmentTime - now.getTimezoneOffset() * 60 * 1000);

        if (diff < 604800 * 1000) {
          activeCount++;
        } else {
        }
      }

      // var weeklyLimit = 10;

      // var createdAtDate = new Date(
      //   this.user.readerStats.created_at.replace(/-/g, "/")
      // );
      // var createdAtTime = createdAtDate.getTime();
      // const createdAtDiff =
      //   nowTime - (createdAtTime - now.getTimezoneOffset() * 60 * 1000);
      // if (createdAtDiff < 604800 * 2 * 1000) {
      //   weeklyLimit = 7;
      // }

      return activeCount >= this.weeklyReadingLimit;
    },
  },
  methods: {
    selectOption(id) {
      if (this.selectedAssignmentId === id) {
        this.selectedAssignmentId = null;
      } else {
        this.selectedAssignmentId = id;
      }
    },
    selectBonus(type) {
      // console.log("selectBonus", type);
      this.selectedBonus = type;
    },
    changeTags(tags) {
      this.selectedTags = tags;

      // De-select any genre item from main list when a genre tag is clicked.
      var tagNames = ["business", "self-help", "health", "mystery", "romance"];
      for (var t in tagNames) {
        var item = tagNames[t];
        if (this.selectedTags.indexOf(item) !== -1) {
          this.selectedGenreId = null;
          this.selectedSubgenreIds = [];
        }
      }

      this.refresh();
    },
    changeLanguageTags(tags) {
      this.selectedLanguages = tags;
      this.refresh();
    },
    clickGenreItem(genreId) {
      if (this.selectedGenreId === genreId) {
        this.selectedGenreId = null;
      } else {
        this.selectedGenreId = genreId;
      }

      this.selectedSubgenreIds = [];

      // De-select any genre tags when a genre item from list is clicked.
      var tagNames = ["business", "self-help", "health", "mystery", "romance"];
      for (var t in tagNames) {
        var item = tagNames[t];
        var index = this.selectedTags.indexOf(item);
        if (index !== -1) {
          this.selectedTags.splice(index, 1);
        }
      }

      this.refresh();
    },
    clickSubgenreItem(subgenreId) {
      this.selectedSubgenreIds.indexOf(subgenreId) === -1 ? this.selectedSubgenreIds.push(subgenreId) : this.selectedSubgenreIds.splice(this.selectedSubgenreIds.indexOf(subgenreId), 1);

      // De-select any genre tags when a genre item from list is clicked.
      var tagNames = ["business", "self-help", "health", "mystery", "romance"];
      for (var t in tagNames) {
        var item = tagNames[t];
        var index = this.selectedTags.indexOf(item);
        if (index !== -1) {
          this.selectedTags.splice(index, 1);
        }
      }

      this.refresh();
    },
    async refresh() {
      console.log("dz refreshing");
      this.isBooksLoaded = false;
      this.recommendations = await Back.recommend({
        tags: this.selectedTags,
        selected_languages: this.selectedLanguages,
        is_standard: this.isStandard,
        is_speedy: this.isSpeedy,
        is_verified: this.isRequiresPurchase,
        selected_genre_id: this.selectedGenreId,
        selected_subgenre_ids: this.selectedSubgenreIds,
        preferred_genre_id: 0, // deprecated
      });
      this.isBooksLoaded = true;
      console.log("dz refreshed");
    },
    selectAssignment(assignment) {
      if (this.selectedAssignmentId === assignment.id) {
        this.selectedAssignmentId = null;
        return;
      }
      if (assignment.is_verified && !this.user.is_choose_your_reward) {
        this.selectedBonus = "snaps";
        console.log("auto select");
      }
      this.selectedAssignmentId = assignment.id;
      this.selectedAssignment = assignment;
    },
    async acceptAssignment() {
      if (!this.selectedAssignment) {
        return;
      }

      try {
        var element = document.createElement("div");
        element.setAttribute("id", "loadingOverlay");
        document.body.appendChild(element);

        const assignment = await Back.startAssignment(
          this.selectedAssignmentId,
          this.selectedBonus
        );
        if (!assignment) {
          // TODO: Display error.
        }
        if (assignment.message) {
          this.$toasted.show(assignment.message, {
            icon: "error",
            position: "bottom-center",
            duration: 3000,
          });
        } else {
          this.$router.push("/assignments/" + this.selectedAssignmentId);
          this.$toasted.show(
            "Great! You're assigned to read " +
              this.selectedAssignment.book.title +
              " now.",
            {
              icon: "check_circle",
              position: "bottom-center",
              duration: 3000,
            }
          );
          this.$store.commit("hideFindBook");
          console.log("emit UserChanged");
          Bus.$emit("UserChanged", this.selectedAssignment.book);
        }
        document.getElementById("loadingOverlay").outerHTML = "";
      } catch (err) {
        // TODO: Display error.
        document.getElementById("loadingOverlay").outerHTML = "";
      }
    },
    hasOneBook(user) {
      for (const book of user.books) {
        if (book.status === "Available" || book.status === "HoldingUnproven") {
          return true;
        }
      }
    },
    getWeeklyLimitEndTime() {
      var now = new Date();
      var nowTime = new Date().getTime();
      var earliestTime = null;
 
      //Filter all assignments for ones which are started within the last week. 
      //Also makes a shallow copy of the assignment obj to prevent mapped state sort looping
      const assignmentsThisWeek = this.assignments.filter(function (assignment) {
        const assignmentDate = new Date(
          assignment.started_at.replace(/-/g, "/")
        );
        const assignmentTime = assignmentDate.getTime();

        const diff =
          nowTime - (assignmentTime - now.getTimezoneOffset() * 60 * 1000);

        return (diff < 604800 * 1000)
      });

      //Sort this week's assignments and take the last 10
      const lastTenAssignments = assignmentsThisWeek.sort(function(a,b){
        return new Date(b.started_at) - new Date(a.started_at);
      }).slice(0,10)

      const lastAssignment = lastTenAssignments[lastTenAssignments.length-1]
      const assignmentDate = new Date(
        lastAssignment.started_at.replace(/-/g, "/")
        );
        earliestTime = assignmentDate.getTime();

      const earliestDate = new Date(
        earliestTime -
          now.getTimezoneOffset() * 60 * 1000 +
          3600 * 24 * 7 * 1000
      );
      console.log("weekly: earliest date", earliestDate, earliestTime);
      const options = { year: "numeric", month: "long", day: "numeric" };

      return (
        earliestDate.toLocaleDateString("en-US", options) +
        " " +
        earliestDate.toLocaleTimeString("en-US")
      );
    },
    getReadingWarningEndTime() {
      var now = new Date();
      var nowTime = new Date().getTime();
      var earliestTime = null;

      for (const assignment of this.assignments) {
        // console.log("weekly: checking assignment", assignment);
        if (!assignment.started_at) {
          continue;
          console.log("weekly: no started_at");
        }

        const assignmentDate = new Date(
          assignment.started_at.replace(/-/g, "/")
        );
        const assignmentTime = assignmentDate.getTime();

        if (assignmentTime < thresholdTime) {
          continue;
        }

        const diff =
          nowTime - (assignmentTime - now.getTimezoneOffset() * 60 * 1000);

        if (diff < 604800 * 1000) {
          if (!earliestTime || assignmentTime < earliestTime) {
            earliestTime = assignmentTime;
            console.log("weekly: new earliest time", earliestTime);
          }
        } else {
          console.log("weekly: too old");
        }
      }

      const earliestDate = new Date(
        earliestTime -
          now.getTimezoneOffset() * 60 * 1000 +
          3600 * 24 * 7 * 1000
      );
      console.log("weekly: earliest date", earliestDate, earliestTime);
      const options = { year: "numeric", month: "long", day: "numeric" };
      //return earliestDate.getTimezoneOffset() / 60;
      return (
        earliestDate.toLocaleDateString("en-US", options) +
        " " +
        earliestDate.toLocaleTimeString("en-US")
      );
    },
    isUserConsideredNew() {
      var now = new Date();
      var nowTime = new Date().getTime();
      var createdAtDate = new Date(
        this.user.readerStats.created_at.replace(/-/g, "/")
      );
      var createdAtTime = createdAtDate.getTime();
      const createdAtDiff =
        nowTime - (createdAtTime - now.getTimezoneOffset() * 60 * 1000);
      if (createdAtDiff < 604800 * 2 * 1000) {
        return true;
      }
      return false;
    },
    bookHelpClicked() {
      this.$router.push("snaps");
      window.scrollTo(0, 0);
    },
  },
  async mounted() {
    console.log("dz mounted");
    await this.refresh();
  },
  watch: {
    user(newValue, oldValue) {
      const user = newValue;
    },
    genres() {},
  },
};

function getBookTitlesFromAssignments(assignments) {
  let bookTitles = assignments.map(a => `<a style="color: #2094f3; font-weight: 600; font-size: 13pt; text-decoration: none;" href="` + document.location.origin  + `/#/assignments/` + a.id + `">` + a.book.title + `</a>`);
  return bookTitles.join(", ").replace(/, ((?:.(?!, ))+)$/, ' and $1');
}
</script>

<style lang="scss" scoped>
.library-mark {
  max-width: 600px;
  margin: 0 auto;
  font-family: $font-family;
}
.library-subhead {
  max-width: 600px;
  margin-left: 0px;
  background: #fff;
  border: 0px solid #333;
  border-radius: 16px;
  padding: 0 0 20px 0;
  text-align: center;
  font-size: 13.5pt;
  font-weight: 500;
}
.library-decoration {
  width: 92px;
  height: 5px;
  margin: 0 auto;
  margin-bottom: 10px;
}
.library-decoration-line {
  float: left;
  background: #222;
  width: 50px;
  height: 5px;
  border-radius: 5px;
}
.library-decoration-circle {
  float: left;
  background: #222;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  margin: 0 8px 0 8px;
}
.library-box {
  max-width: 400px;
  margin: auto;
  background: #fff;
  border: 0px solid #333;
  border-radius: 16px;
  padding: 12px;
  text-align: center;
  font-size: 17pt;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.library-line1,
.library-line2,
.library-line3 {
  position: relative;
  height: 1px;
  background: #333;
  display: none;
}
.library-line1 {
  width: 500px;
  margin-left: 50px;
  margin-top: -20px;
}
.library-line2 {
  width: 580px;
  margin-left: 10px;
  margin-top: -20px;
}
.library-line3 {
  width: 500px;
  margin-left: 50px;
  margin-top: -10px;
}

.reading-discount-container {
  position: relative;
  margin: 150px 30px 0 30px;
}
.reading-discount-box {
  position: fixed;
  width: 220px;
  height: 231px;
  top: 500px;
  background: #fff;
  border-radius: 12px;
  border: 2px solid #f3f3f3;
  //box-shadow: 0px 1px 0.3rem rgba(116, 75, 75, 0.15);
  font-family: $font-family;
}

.credit-bonus-text {
  color: darken(#4caf50, 5%);
  font-weight: 700;
}
.snaps-bonus-text {
  color: darken($color-snaps, 0%);
  font-weight: 600;
}
.snaps-bonus-more {
  color: #777;
  font-weight: 500;
}

.title-text {
    color: $color-blue !important;
    font-weight: 600 !important;
    font-size: 12.5pt !important;
    padding-right: 2px !important;
  }

.filters {
  display: none;
  position: relative;
  padding: 150px 30px 0 30px;
}
.filters-box {
  position: fixed;
  width: 220px;
  height: 260px;
  background: #fafafa;
  border-radius: 12px;
  border: 2px solid #f3f3f3;
  //box-shadow: 0px 1px 0.3rem rgba(116, 75, 75, 0.15);
  font-family: $font-family;
}
.filters-heading {
  display: flex;
  padding: 20px 20px 6px 20px;
}
.filters-list {
  border-bottom: 2px solid #f3f3f3;
}
.filters-icon {
  font-size: 17pt;
  color: #666;
}
.filters-heading-text {
  padding-left: 7px;
  font-size: 12.5pt;
  font-weight: 600;
  color: #666;
}

.filters-item {
  width: 100%;
  padding: 12px 0 12px 0;
  background: #fff;
  border-top: 2px solid #f3f3f3;
  display: flex;

  .filters-checkbox {
    margin: 0px 0px 4px 16px;
    width: 28px;
    min-width: 28px;
    height: 22px;
    border: 0px solid #eee;
    border-radius: 4px;
  }
  .filters-checkbox:hover {
    cursor: pointer;
    opacity: 0.7;
  }

  .filters-checkbox-checked {
    color: $color-blue;
  }

  // .checkbox-icon {
  //   color: #ccc;
  // }

  .filters-label {
    padding-left: 2px;
    padding-top: 0px;
    font-size: 13pt;
    font-weight: 500;
    color: #333;
  }
}

@media (max-width: 1024px) {
  .filters,
  .reading-discount-container {
    position: static !important;
    padding-top: 0px !important;
  }

  .reading-discount-container {
    padding-top: 30px !important;
    padding-bottom: 30px !important;
  }

  .filters-box,
  .reading-discount-box {
    position: static !important;
    margin: 0 auto !important;
  }
}

.modal-title {
  border-bottom: 1px solid #e3e3e3;
  padding: 0.5em;
  padding-left: 60px;
  font-size: 21pt;
  font-weight: 500;
  color: #111;
  text-align: center;
}
.modal-instructions {
  padding-top: 16px;
  font-size: 14pt;
  color: #111;
  text-align: center;
}
.modal-limit-instructions {
  padding: 60px 120px;
  font-size: 13.5pt;
  color: #111;
  text-align: center;
}
.modal-close {
  font-size: 15pt;
  margin-top: 10px;
  margin-right: 16px;
  padding: 7px 0 0 6.5px;
  width: 36px;
  height: 36px;
  border-radius: 100px;
  float: right;
  position: relative;
  transition: all 0.2s ease-in-out;
}
.modal-close:hover {
  background: #eee;
  transform: scale(1.1);
  cursor: pointer;
}

.hang-arrow {
  opacity: 0.5;
  transition: all 0.2s ease-in-out;
}
.hang-arrow:hover {
  opacity: 1;
  cursor: pointer;
}

.find-book {
  background: #fff;
  box-shadow: 0 0 1.5rem rgba(0, 0, 0, 0.14);
  font-family: $font-family;
}

.over-container {
  max-width: 980px;
  padding-top: 20px !important;
  padding-bottom: 12px !important;
  padding: 12px !important;
}
.books-container {
  min-height: 264px;
}

.actions {
  display: flex;
  justify-content: center;
  padding: 4px;
  padding-right: 25%;
}
.action-blue {
  background: #daedff;
  color: #2196f3;
}

@media (max-height: 780px) {
  .filters {
    padding-top: 100px !important;
  }
  .reading-discount-box {
    top: 450px !important;
  }
}
@media (max-height: 700px) {
  .filters {
    padding-top: 60px !important;
  }
  .reading-discount-box {
    top: 410px !important;
  }
}

@media (max-width: 1024px) {
  .actions {
    padding-right: 0 !important;
  }
  .modal-container {
    padding-left: 0 !important;
    padding-right: 0 !important;
    height: 30% !important;
    top: 70% !important;
  }
}
@media (max-width: 480px) {
  .actions {
    padding-right: 0 !important;
  }
  .modal-container {
    padding-left: 0 !important;
    padding-right: 0 !important;
    height: 35% !important;
    top: 65% !important;
  }
  .modal-tall {
    height: 70% !important;
    top: 30% !important;
  }

  .confirm-text {
    padding-left: 16px;
    padding-right: 20px;
  }

  .close-container {
    max-width: 83%;
    padding-right: 25%;
  }
}

.close-container {
  width: 100%;
  padding-right: 25%;
  position: relative;
}
.close-button {
  position: absolute;
  width: 100%;
  top: -4px;
  right: -40px;
  width: 33px;
  height: 33px;
  background: #fff;
  border: 2px solid #eee;
  color: #666;
  font-size: 13pt;
  font-weight: 600;
  border-radius: 30px;
  padding-top: 5px;
  cursor: pointer;
}
.close-button:hover {
  border: 2px solid #ddd;
}
.close-button-icon {
  font-size: 12pt;
}

.action-selection {
  flex-grow: 0;
  text-align: center;
  max-width: 800px;
  width: 100%;
}
.action-refresh {
  flex-grow: 0;
  flex-basis: 260px;
  margin-left: auto;
  padding-right: 48px;
  text-align: center;
}
.action-refresh-item {
  float: right;
  width: 120px;
  text-align: center;
  border: 0px solid #f3f3f3;
  border-radius: 8px;
  margin: 0 8px;
  padding: 0.4em 0.75em;
  font-size: 12pt;
  color: #777;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
}
.action-refresh-item:hover {
  cursor: pointer;
  color: #999;
}
// .action {
//   background: #ede7f6;
//   color: #9575cd;
// }

@media (max-width: 1024px) {
  .action-refresh {
    flex-basis: 140px;
    padding-right: 0;
  }
}

.confirm-text {
  height: 60px;
  padding-top: 16px;
  max-width: 820px;
  margin: 0 auto;
  font-size: 11.5pt;
  line-height: 1.5em;
  color: #333;
  text-align: center;
}
.points-text {
  color: darken($color-snaps, 0%);
  font-weight: 700;
}
.book-title {
  color: $color-blue;
  font-weight: 500;
}
.discount-title {
  color: #555;
  font-weight: 700;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

@media (max-width: 1024px) {
  .modal-mask {
    position: absolute !important;
  }
  .modal-container {
    height: auto;
    width: 100%;
    max-width: 100%;
    padding: 20px 0;
  }

  .modal-title {
    text-align: left;
    font-size: 19pt;
    padding-top: 1px;
    padding-left: 18px;
    padding-right: 0;
  }

  .modal-close {
    float: right !important;
    position: initial !important;
    margin-right: 12px !important;
  }
}

.hang-arrow {
  float: left;
  width: 50px;
  padding: 120px 0 0 0;
  text-align: center;
}
.hang-arrow-right {
  float: right;
}
.hang-arrow-i {
  font-size: 48px;
  color: #111;
}

.modal-container {
  position: fixed;
  width: 100%;
  height: 25%;
  top: 75%;
  left: 0;
  margin: 0px auto;
  padding: 8px 0px 12px 0px;
  background-color: #fff;
  border-top: 2px solid #eee;
  padding: 20px 80px 20px 300px;
  font-family: "Source Sans Pro";
  z-index: 1000;
}

.modal-tall {
  height: 40%;
  top: 60%;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.limit-title {
  padding: 50px 24px 24px 24px;
  font-family: $font-family;
  font-size: 21pt;
  text-align: center;
}
.limit-limit-instructions {
  padding: 0px 40px;
  font-family: $font-family;
  font-size: 12.5pt;
  text-align: center;
}
.limit-limit-instructions-left {
  text-align: left;
  padding: 0 90px;
}

.content-container {
  border-bottom: 0 !important;
}

.books-list-heading {
  width: 100%;
  height: 64px;
  padding: 0.75em 0 0em 0;
  margin: 0 34px 0px 34px;
  font-size: 19pt;
  font-weight: 500;
  color: #111;
  font-family: $font-family;
}
.books-list-label {
  float: left;
}
.books-list-selection {
  float: right;
  width: 400px;
  margin-top: -14px;
}

.earncall {
  width: 540px;
  margin: 0 auto;

  .earncall-card {
    min-height: 210px;
    background: #fff;
    //box-shadow: 0px 1px 0.5rem rgba(116, 75, 75, 0.25);
    margin: 12px 16px;
    padding: 0px 0;
    padding-bottom: 0 !important;
    border-radius: 8px;
    font-family: "Source Sans Pro";
    text-align: center;
  }

  .earncall-icon {
    text-align: center;
    margin: 0px 0 0px 0;
    padding-top: 20px;
  }
  .earncall-icon-img {
    width: 80px;
  }

  .earncall-heading {
    padding: 0px 0 0 0;
    font-size: 19pt;
    color: darken($color-blue, 0%);
    color: #111;
    font-weight: 600;
    text-align: center;
    font-family: "Source Sans Pro";
  }

  .earncall-description {
    font-size: 12.5pt;
    padding: 12px 40px 16px 40px;
    font-family: "Source Sans Pro";
    text-align: center;
  }
}
@media (max-width: 480px) {
  .earncall {
    width: 340px;
    margin: 0 auto;
  }
}

.library-loading {
  width: 300px;
  margin: 0 auto;
  text-align: center;

  .library-loading-gif {
    width: 260px;
  }
  .library-loading-label {
    margin-top: -36px;
    font-size: 13pt;
    color: $color-blue;
    text-align: center;
    font-family: "Source Sans Pro";
    opacity: 0.9;
  }
}

.grow {
  transition: all 0.1s ease-in-out;
  cursor: pointer;
}
.grow:hover {
  transform: scale(1.03);
}

@media (max-height: 690px) {
  .modal-tall {
    height: 44% !important;
    top: 56% !important;
  }

  .earncall {
    display: none;
  }
}

.library-books-container {
  max-width: 960px;
  padding: 0 0 0 12px !important;
  margin: 0 !important;
}

.content-top-container {
  //max-width: 900px;
  border-bottom: 2px solid #f1f1f1 !important;
  margin-left: 0 !important;
  //padding-left: 0 !important;
}

.library-img {
  width: 95%;
  max-width: 690px;
  margin-left: 28px;
  text-align: center;
}

.genrelist-container {
  padding-left: 12px;
}

.books-refreshing {
  opacity: 0.5;
}

.date {
  font-weight: 600;
  color: #4caf50;
}

.policy-warning-container {
  display: none;
}

.policy-warning {
  display: flex;
  background: lighten(#ffecb3, 10%);
  border: 2px solid lighten(#ffecb3, 0%);
  border-radius: 10px;
  padding: 1em;
  padding-bottom: 0;
}
.policy-warning-image {
  width: 100px;
}
.policy-warning-image-img {
  width: 70px;
  margin-right: 16px;
}
.policy-warning-text {
  font-family: $font-family;
  font-size: 11.5pt;
  line-height: 1.3em;
}
@media (max-width: 480px) {
  .policy-warning {
    display: block;
  }
  .policy-warning-image {
    display: none;
  }
}

@media (max-width: 1450px) {
  .library-books-container {
    max-width: 960px;
    padding: 0 0 0 0px !important;
    margin: 0 !important;
  }

  .library-img {
    // margin-left: 12px !important;
  }

  .content-top-container {
    //max-width: 900px;
    border-bottom: 2px solid #f1f1f1 !important;
    margin-left: 0 !important;
    padding-left: 8px !important;
    //padding-left: 0 !important;
  }

  .content-main-container {
    padding-left: 20px !important;
  }

  .genrelist-container {
    padding-left: 28px;
  }
}

@media (max-width: 1024px) {
  .library-books-container {
    max-width: 960px;
    padding: 0 0 0 0px !important;
    margin: 0 !important;
  }

  .library-img {
    margin-left: 12px !important;
  }

  .content-top-container {
    //max-width: 900px;
    border-bottom: 2px solid #f1f1f1 !important;
    margin-left: 0 !important;
    padding-left: 8px !important;
    //padding-left: 0 !important;
  }
}
</style>